import InspectionProfileTableData from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/inspectionProfileTableData";
import generateDefaultProviderPanelRow from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/defaultProviderPanelRow";
import { getLocationConfidenceTooltip } from "@app/projects/network-assessment/accuracy/AccuracyInspectionWaffleTooltips";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { AccuracyProviderDetail } from "@app/projects/results/accuracy/accuracyProviderDetail";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

/* oxlint-disable sort-keys */
export const generateLocationConfidenceScoreRow = (rowKey: string, title: string, sourceRecord: AccuracyProviderDetail): InspectionProfileTableData => {
  const locationConfidenceScoreData = generateDefaultProviderPanelRow(rowKey, title, null, sourceRecord.inspectionSupplement.practitionerAtLocationConfidence);
  locationConfidenceScoreData.source = null;
  locationConfidenceScoreData.result = sourceRecord.inspectionSupplement.practitionerAtLocationConfidence
    ? <> {sourceRecord.inspectionSupplement.practitionerAtLocationConfidence.value}
      <TooltipWrapper text={getLocationConfidenceTooltip(sourceRecord.inspectionSupplement.practitionerAtLocationConfidence.value)} containerClassName="ms-1">
        <QesIcon iconName={QesIcons.InfoCircle} description="Info" className="align-top" />
      </TooltipWrapper></>
    : locationConfidenceScoreData.result;
  return locationConfidenceScoreData;
}